import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp'
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons/faPenToSquare'
import { faSquarePlus } from '@fortawesome/free-solid-svg-icons/faSquarePlus'
import { faSquareMinus } from '@fortawesome/free-solid-svg-icons/faSquareMinus'
import { faVideo } from '@fortawesome/free-solid-svg-icons/faVideo'
import { faHeadphones } from '@fortawesome/free-solid-svg-icons/faHeadphones'
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe'
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy'
import { CPProblem } from '../models/CPProblem'
import { Collapse } from 'react-bootstrap';
import ImageDisplayComponent from './ImageDisplayComponent';
import { CPImageAlignment } from '../enums/CPImageAlignment';
import { CPLinkType } from '../enums/CPLinkType';
import { CPReactMethods } from '../app';
import DeleteConfirmationModalComponent from './DeleteConfirmationModalComponent'
import ThreeOptionModalComponent from './ThreeOptionModalComponent';
import ConfirmationModalComponent from './ConfirmationModalComponent'
import { useState } from 'react';
import AssignmentBuilderPartItem from './AssignmentBuilderPartItem';

export interface AssignmentBuilderProblemCardProps {
    problem: CPProblem
    problemIndex: number
    problemsLength: number
    showGuid: boolean
    showEquations: boolean
    showHelp: boolean
    showTags: boolean
    answeredInAssignment: boolean
    problemUserIsOwner: boolean
    problemInMultiplePlaces: boolean
    defaultPointValue: number
    defaultMaxAttempts: number
    defaultUnpenalizedAttempts: number
    defaultPenalty: number
    defaultPlusMinus: number
    defaultPlusMinusIsPercent: boolean
    moveProblemUp: Function
    moveProblemDown: Function
    editProblem: Function
    isGlobalAdmin: Function
    calculateProblemPoints: Function
    changePointValue: Function
    changeMaxAttempts: Function
    changeUnpenalizedAttempts: Function
    changePenalty: Function
    changePlusMinus: Function
    changePlusMinusIsPercent: Function
    removeProblemInstance: Function
    addBlankProblem: Function
    setAddProblemIndex: Function
    setIsAddingProblem: Function
    addNewProblems: Function
    cloneProblem: Function
}

const AssignmentBuilderProblemCard = (props: AssignmentBuilderProblemCardProps) => {
    const [hideProblem, setHideProblem] = useState(false)
    return (
        <div className="card my-3" id={"problem" + (props.problemIndex + 1).toString()} >
            <div className="card-header">
                <div className="row align-items-center">

                    {/* @ts-ignore */}
                    <div className="col" role="button" onClick={() => setHideProblem(!hideProblem)} style={{ color: "inherit", textDecoration: "inherit" }}>

                        <span className="fw-bold fs-4">{hideProblem ? <FontAwesomeIcon icon={faPlus} /> : <FontAwesomeIcon icon={faMinus} />}</span>
                        <b>&emsp;{props.problemIndex + 1}. &emsp;{props.problem.name}</b>

                    </div>
                    {props.showGuid ?
                        <div className="col-auto">
                            {props.problem.guid}
                        </div> : ""}
                    <div className="col-auto align-self-center">
                        {props.problemIndex > 0 ? <a><FontAwesomeIcon icon={faAngleUp} onClick={() => props.moveProblemUp(props.problemIndex)} role="button" /><br /></a> : ""}

                        {props.problemIndex != props.problemsLength - 1 ? <a><FontAwesomeIcon icon={faAngleDown} onClick={() => props.moveProblemDown(props.problemIndex)} role="button" /></a> : ""}
                    </div>
                    <div className="col-auto align-self-center">
                        <a><FontAwesomeIcon title="Edit" icon={faPenToSquare} size="lg" role="button" onClick={() => { props.editProblem(props.problem); window.scrollTo(0, 0) }} /></a>&nbsp;


                        {!props.problemUserIsOwner || props.problemInMultiplePlaces[props.problem.id!] ?
                            <><a><FontAwesomeIcon title="Clone" icon={faCopy} size="lg" role="button" data-bs-toggle="modal" data-bs-target={"#cloneProblemModal" + props.problemIndex} /></a>&nbsp;</>
                            : ""}
                        <a><FontAwesomeIcon title="Add" icon={faSquarePlus} size="lg" role="button" data-bs-toggle="modal" data-bs-target={"#addBlankOrPremadeProblemModal" + props.problemIndex} /></a>&nbsp;
                        {!props.answeredInAssignment ?
                            <a><FontAwesomeIcon title="Remove" icon={faSquareMinus} size="lg" role="button" data-bs-toggle="modal" data-bs-target={"#removeProblemModal" + (props.problemIndex + 1)} /></a>
                            : ""}
                    </div>
                    {!props.isGlobalAdmin() ?
                        <div className="col-auto align-self-center">
                            <div className="row align-items-end">
                                <div className="col text-center"><b>Total Point Value</b></div>
                            </div>
                            <div className="row">
                                <div className="col"><div className="row"><input type="text" readOnly onChange={() => { }} className="form-control form-control-sm text-center col ms-3 me-1" value={props.calculateProblemPoints(props.problem)} />{props.defaultPointValue * props.problem.parts.length == props.calculateProblemPoints(props.problem) ? "" : <b className="col-auto p-0">*</b>}</div></div>
                            </div>
                        </div> : ""}
                </div>
            </div>
            <Collapse in={!hideProblem}>
                <div className="card-body align-items-center">
                    <div className="row">
                        <ImageDisplayComponent
                            image={props.problem.image}
                            alignment={CPImageAlignment.Left}
                            isForMobile={false}
                        />
                        <ImageDisplayComponent
                            image={props.problem.image}
                            alignment={CPImageAlignment.Above}
                            isForMobile={false}
                        />
                        <div className="col card-title">

                            <div dangerouslySetInnerHTML={{ __html: props.problem.text! }}></div>

                        </div>
                        <ImageDisplayComponent
                            image={props.problem.image}
                            alignment={CPImageAlignment.Right}
                            isForMobile={false}
                        />
                    </div>
                    <ImageDisplayComponent
                        image={props.problem.image}
                        alignment={CPImageAlignment.Middle}
                        isForMobile={false}
                    />
                    <ol className="partList">
                        {props.problem.parts.map((part, partIndex) => {
                            return (
                                <AssignmentBuilderPartItem
                                    key={part.instanceId}
                                    part={part}
                                    problemIndex={props.problemIndex}
                                    partIndex={partIndex}
                                    partsLength={props.problem.parts.length}
                                    showEquations={props.showEquations}
                                    answeredInAssignment={props.answeredInAssignment}
                                    defaultPointValue={props.defaultPointValue}
                                    defaultMaxAttempts={props.defaultMaxAttempts}
                                    defaultUnpenalizedAttempts={props.defaultUnpenalizedAttempts}
                                    defaultPenalty={props.defaultPenalty}
                                    defaultPlusMinus={props.defaultPlusMinus}
                                    defaultPlusMinusIsPercent={props.defaultPlusMinusIsPercent}
                                    isGlobalAdmin={props.isGlobalAdmin}
                                    changePointValue={props.changePointValue}
                                    changeMaxAttempts={props.changeMaxAttempts}
                                    changeUnpenalizedAttempts={props.changeUnpenalizedAttempts}
                                    changePenalty={props.changePenalty}
                                    changePlusMinus={props.changePlusMinus}
                                    changePlusMinusIsPercent={props.changePlusMinusIsPercent} />
                            )
                        })}
                    </ol>
                    <ImageDisplayComponent
                        image={props.problem.image}
                        alignment={CPImageAlignment.Below}
                        isForMobile={false}
                    />
                    {props.problem.helpText && props.showHelp ?
                        <div className="row">
                            <div className="col">
                                <div className="row">
                                    <b>Help Text</b>
                                </div>
                                <div className="row">
                                    <div className="col" dangerouslySetInnerHTML={{ __html: props.problem.helpText }}></div>
                                </div>
                            </div>
                        </div> : ""
                    }
                    {props.problem.links && props.showHelp ?
                        props.problem.links.length > 0 ?
                            <div className="row">
                                <div className="col">
                                    <div className="row">
                                        <b>Help Links</b>
                                    </div>
                                    <div className="row">
                                        <span>
                                            {props.problem.links.map(link => {
                                                return (
                                                    <a key={link.url} href={link.url} target="_blank"><FontAwesomeIcon className="mx-2" icon={link.type == CPLinkType.Video ? faVideo : link.type == CPLinkType.Audio ? faHeadphones : faGlobe} size="lg" color="black" /></a>
                                                )
                                            })}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            : "" : ""}
                    {props.showTags && props.problem.tags && props.problem.tags.length > 0 ?
                        <div className="row">
                            <div className="col">
                                <div className="row">
                                    <b>Tags</b>
                                </div>
                                <div className="row">
                                    <ul className="list-unstyled">
                                        {props.problem.tags.map((tag, tagIndex) => {
                                            return (
                                                <li key={tagIndex}>
                                                    {tag}
                                                </li>
                                            )
                                        })
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                        : ""
                    }
                </div>
            </Collapse>


            <DeleteConfirmationModalComponent
                itemId={"removeProblemModal" + (props.problemIndex + 1)}
                itemContent={"Do you want to remove Problem " + (props.problemIndex + 1) + " from this assignment?"}
                deleteFunction={() => props.removeProblemInstance(props.problem)}
            />
            <ThreeOptionModalComponent
                itemId={"addBlankOrPremadeProblemModal" + props.problemIndex}
                itemContent="Do you want to add a blank problem, select an already existing one, or add this problem another time?"
                button1Function={() => { props.addBlankProblem(props.problemIndex + 1) }}
                button1Text="Create Blank Problem"
                button1Href="#"
                button2Function={() => { props.setAddProblemIndex(props.problemIndex + 2); props.setIsAddingProblem(true); }}
                button2Text="Select Existing Problems"
                button2Href="#"
                button3Function={() => { props.setAddProblemIndex(props.problemIndex + 2); props.addNewProblems([props.problem.guid!], props.problemIndex + 2); }}
                button3Text="Add This Problem Again"
                button3Href={undefined}
            />
            <ConfirmationModalComponent
                itemId={"cloneProblemModal" + props.problemIndex}
                itemContent="Do you want to replace this problem with your own cloned version?"
                accept={() => props.cloneProblem(props.problem, props.problemIndex)} />
        </div>
    );
};

export default AssignmentBuilderProblemCard;